import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Col, Form, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

export const TransactionBatchModel = ({ isOpen, toggle, itemList, itemTax, SetDataToDetTable }) => {
    const batchItems = itemList.map(item => ({
        ...item,
        m_TBLTaxDetails: itemTax,
    }));

    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState("");

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
    };


    useEffect(() => {
        if (isOpen) {
            setSearch("");
            setPageNo(1);
        }
    }, [isOpen]);



    const filteredItems = batchItems.filter(item => {
        return (
            item.strStockCode.toLowerCase().includes(search.toLowerCase()) ||
            item.strProductCode.toLowerCase().includes(search.toLowerCase()) ||
            item.manualBatch.toLowerCase().includes(search.toLowerCase()) 
        );
    });


    const indexOfLastPost = pageNo * pageSize;
    const indexOfFirstPost = indexOfLastPost - pageSize;
    const currentPosts = filteredItems.slice(indexOfFirstPost, indexOfLastPost);



    return (
        <div>
            <Modal
                size="xl"
                isOpen={isOpen}
                toggle={toggle}
                style={{ maxWidth: '90%', width: '90%' }}
                centered={true}
                backdrop="static">
                <ModalHeader toggle={toggle}>Select Batch</ModalHeader>

                <ModalBody>

                    <Row className="mb-4">

                    </Row>

                    <Row className="mb-4"> {/* Add bottom margin to the Row */}
                        <Col>
                            <div className="mx-4">
                                <input id="SearchBar"
                                    type="text"
                                    className="form-control"
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                    style={{ height: '28px', width: '300px' }}
                                    placeholder="Search by Batch Code"
                                    maxLength={30}
                                    value={search}
                                    onChange={e => {
                                        setSearch(e.target.value);
                                        setPageNo(1)
                                    }} />
                                <table className="custom-table table-bordered table-sm rounded mx-auto mb-4">
                                    <thead className="table-secondary">
                                        <tr style={{ height: '40px' }}>
                                            <td style={{ fontWeight: 'bold' }}>#</td>
                                            <td>Code</td>
                                            <td>Batch Code</td>
                                            <td>Reference Code</td>
                                            <td>Description</td>
                                            <td>Unit</td>
                                            <td>Expiry Date</td>
                                            <td>SIH</td>
                                            <td>Cost</td>
                                            <td>Sell</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPosts.map((item, index) => (
                                            <tr key={index} onClick={() => {
                                                SetDataToDetTable(item);
                                                toggle();
                                            }}>
                                                <td>{indexOfFirstPost + index + 1}</td>
                                                <td>{item.strProductCode}</td>
                                                <td>{item.strStockCode}</td>
                                                <td>{item.manualBatch}</td>
                                                <td>{item.strProductDesc}</td>
                                                <td>{item.strUnitDesc}</td>
                                                <td>{item.pluExpiery.slice(0, 10) == "1900-01-01" ? "" : item.pluExpiery.slice(0, 10)}</td>
                                                <td>{item.dbSIH}</td>
                                                <td>{parseFloat(item.dbAvgCost).toFixed(2)}</td>
                                                <td>{parseFloat(item.dbSelling).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(filteredItems.length / pageSize)}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                forcePage={pageNo - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-center pagination-sm'}
                            />
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </div>
    );
};
